<div class="reset-password-page">
  <div class="reset-password-page__container">
    @switch (currentState()) { @case ('loading') {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
      } @case ('form') {
      <ng-container *ngTemplateOutlet="form"></ng-container>
      } @case ('success') {
      <ng-container *ngTemplateOutlet="success"></ng-container>
      } @case ('invalid-token') {
      <ng-container *ngTemplateOutlet="invalidToken"></ng-container>
      } @case ('error') {
      <ng-container *ngTemplateOutlet="error"></ng-container>
      } }

      <ng-template #loading>
        <div class="reset-password-page__loading" data-testid="loading-state">
          <mat-spinner diameter="48"></mat-spinner>
          <p class="reset-password-page__loading-text">Loading...</p>
        </div>
      </ng-template>

      <ng-template #form>
        <div class="reset-password-page__form-container" data-testid="form-state">
          <div class="reset-password-page__header">
            <mat-icon class="reset-password-page__icon" color="primary">lock_reset</mat-icon>
            <h1 class="reset-password-page__title">Reset Your Password</h1>
            <p class="reset-password-page__subtitle">Enter your new password below. Make sure it's at least 8 characters long.</p>
          </div>

          <wil-reset-password-form [token]="token" (goHome)="goToHome()"></wil-reset-password-form>
        </div>
      </ng-template>

      <ng-template #success>
        <div class="reset-password-page__success" data-testid="success-state">
          <div class="reset-password-page__success-icon">
            <mat-icon color="primary">check_circle</mat-icon>
          </div>
          <h1 class="reset-password-page__success-title">Password Reset Successfully</h1>
          <p class="reset-password-page__success-message">Your password has been updated. You can now log in with your new password.</p>
          <div class="reset-password-page__success-actions">
            <wil-cta-button
              [ctaText]="'Go to Login'"
              (ctaClick)="handleLogin()"
              [style]="'primary'"
              [size]="'large'"
              data-testid="reset-password-page-go-to-login-button"
            ></wil-cta-button>
          </div>
        </div>
      </ng-template>

      <ng-template #invalidToken>
        @if (currentState() === 'invalid-token') {
          <div class="reset-password-page__invalid" data-testid="invalid-token-state">
            <div class="reset-password-page__invalid-icon">
              <mat-icon color="warn">link_off</mat-icon>
            </div>
            <h1 class="reset-password-page__invalid-title">Invalid or Expired Link</h1>
            <p class="reset-password-page__invalid-message">This link is invalid or expired. Request a new one.</p>
            <div class="reset-password-page__invalid-actions">
              <wil-cta-button
                [ctaText]="'Request New Link'"
                (ctaClick)="requestNewLink()"
                [style]="'primary'"
                [size]="'large'"
                data-testid="reset-password-page-request-new-link-button"
              ></wil-cta-button>
              <button type="button" mat-button (click)="goToHome()" data-testid="invalid-back-to-home-button">Back to Home</button>
            </div>
          </div>
        }
      </ng-template>

      <ng-template #error>
        <div class="reset-password-page__error" data-testid="error-state">
          <div class="reset-password-page__error-icon">
            <mat-icon color="warn">error</mat-icon>
          </div>
          <h1 class="reset-password-page__error-title">Something Went Wrong</h1>
          <p class="reset-password-page__error-message">
            We encountered an issue while resetting your password. Please try again or request a new reset link.
          </p>
          <div class="reset-password-page__error-actions">
            <wil-cta-button
              [ctaText]="'Try Again'"
              (ctaClick)="currentState.set('form')"
              [style]="'primary'"
              [size]="'large'"
              data-testid="reset-password-page-retry-button"
            ></wil-cta-button>
            <button type="button" mat-button (click)="requestNewLink()" data-testid="error-request-new-link-button">Request New Link</button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
